import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../TextField/TextFeild";
import SelectBox from "../CountryDropDownAdmin/SelectBox";
import { addTeamMember } from "../../store/slices/teamSlice";

const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    password: Yup.string().required("Password is required"),
    passwordRepeat: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    roles: Yup.array().required("Role is required"),
});

const AddMember = ({ show, onClose }) => {
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            password: '',
            passwordRepeat: '',
            roles: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const submitValues = { ...values };
            delete submitValues.passwordRepeat;
            dispatch(addTeamMember({ message: "Team member created.", palyload: { id: values.email, values: submitValues } })).unwrap().then(()=>{
                onClose()
            })

        },
    });

    useEffect(() => {
        if (show) {
            formik.resetForm();
        }
    }, [show]);


    return (
        <Modal show={show} size="md" onHide={onClose} centered backdrop="static" keyboard={false}>

            <form className="" onSubmit={formik.handleSubmit}>
                <div className="form-card shadow-none">
                    <div className="">
                        <CustomInput
                            label="First Name"
                            id="firstName"
                            name="firstName"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.firstName && formik.errors.firstName}
                            required
                        />

                        <CustomInput
                            label="Last Name"
                            id="lastName"
                            name="lastName"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.lastName && formik.errors.lastName}
                            required
                        />

                        <CustomInput
                            label="Email"
                            id="email"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && formik.errors.email}
                            required
                        />
                        <CustomInput
                            label="Password"
                            id="password"
                            name="password"
                            type="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.password && formik.errors.password}
                            required
                        />
                        <CustomInput
                            label="Repeat Password"
                            id="passwordRepeat"
                            name="passwordRepeat"
                            type="password"
                            value={formik.values.passwordRepeat}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.passwordRepeat && formik.errors.passwordRepeat}
                            required
                        />



                        <SelectBox
                            name="roles"
                            selectedValue={formik.values.roles}
                            onChangeFn={(value) => {
                                formik.setFieldValue("roles", value);
                            }}
                            label="Role"
                            options={[{ label: "DJ", value: ['dj'] },{ label: "Admin", value: ['admin'] }]}
                            onBlur={formik.handleBlur}
                            value={formik.values.roles}
                            error={formik.touched.roles && formik.errors.roles}
                            isSearchable={false}
                        />



                    </div>
                </div>
                <div className="text-right p-3">
                    <div className="button-div ">
                        <button type="submit" className="btn btn-outline-danger mx-3" disabled={formik.isSubmitting} onClick={onClose}>
                            <span>Cancel</span>
                        </button>
                        <button type="submit" className="btn btn-secondary" disabled={formik.isSubmitting}>
                            <span>{formik.isSubmitting ? "Creating..." : "Create"}</span>
                        </button>

                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default AddMember;
